if (process.browser) {
document.addEventListener("DOMContentLoaded", function(){
    // Apertura del buscador en el click de la lupa
    document.querySelector(".header-search").addEventListener("click", function(){
        document.querySelector(".buscador").classList.toggle("opened")//.trigger("classChanged");
        document.querySelector(".site-header .header-logo-link p").classList.toggle("hide-me");
    });

    // Cierre en el click del buscador
    document.querySelector(".close-search").addEventListener("click", function(){
        document.querySelector(".buscador").classList.remove("opened");
        document.querySelector(".site-header .header-logo-link p").classList.remove("hide-me");
    });

    // Cierre del buscador en el scroll si ya estaba abierto
    document.querySelector(".buscador").addEventListener("classChanged", function(){
        if( document.querySelector(".buscador").hasClass("opened") ){
            window.onscroll=(function(){
                document.querySelector(".buscador").classList.remove("opened");
            });
        }
    });
})
}